import React, { useState, useEffect } from 'react';
import { AnimatePresence } from 'framer-motion';
import LoadingScreen from './components/LoadingScreen';
import Header from './components/Header';
import SearchSection from './components/SearchSection';
import StatsSection from './components/StatsSection';
import Footer from './components/Footer';
import useTheme from './hooks/useTheme';
import useLanguage from './hooks/useLanguage';
import './App.css';

function App() {
  const [isLoading, setIsLoading] = useState(true);
  const [theme, setTheme] = useTheme();
  const { language } = useLanguage();

  useEffect(() => {
    // Mostrar pantalla de carga inicial
    const timer = setTimeout(() => {
      setIsLoading(false);
    }, 3000);
    
    return () => clearTimeout(timer);
  }, []);

  const handleLoadingComplete = () => {
    setIsLoading(false);
  };

  return (
    <div className="min-h-screen bg-gray-50 dark:bg-gray-900 transition-colors duration-300">
      <AnimatePresence mode="wait">
        {isLoading ? (
          <LoadingScreen key="loading" onComplete={handleLoadingComplete} />
        ) : (
          <div key="main">
            <Header theme={theme} setTheme={setTheme} />
            <main>
              <SearchSection />
              <StatsSection />
            </main>
            <Footer />
          </div>
        )}
      </AnimatePresence>
    </div>
  );
}

export default App;